/**
 * HTTPS enforcement utility
 * Redirects HTTP traffic to HTTPS in production
 */

/**
 * Checks if the current protocol is HTTPS and redirects if necessary
 */
export function enforceHttps(): void {
  // Only enforce in production environment
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  // Check if we're not on HTTPS and not on localhost
  if (
    typeof window !== 'undefined' &&
    window.location.protocol === 'http:' &&
    !window.location.hostname.includes('localhost') &&
    !window.location.hostname.includes('127.0.0.1')
  ) {
    // Redirect to HTTPS version
    const httpsUrl = window.location.href.replace('http:', 'https:');
    console.log('Redirecting to HTTPS:', httpsUrl);
    window.location.replace(httpsUrl);
  }
}

/**
 * Sets Strict-Transport-Security header directive via meta tag
 */
export function setHSTSMeta(): void {
  if (typeof document !== 'undefined') {
    // Check if HSTS meta is already set
    const existingMeta = document.querySelector('meta[http-equiv="Strict-Transport-Security"]');
    
    if (!existingMeta) {
      const meta = document.createElement('meta');
      meta.httpEquiv = 'Strict-Transport-Security';
      meta.content = 'max-age=31536000; includeSubDomains; preload';
      document.head.appendChild(meta);
    }
  }
}

/**
 * Validates if a URL uses HTTPS
 */
export function isSecureUrl(url: string): boolean {
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Converts HTTP URLs to HTTPS
 */
export function makeUrlSecure(url: string): string {
  if (!url) return url;
  
  try {
    const urlObj = new URL(url);
    if (urlObj.protocol === 'http:') {
      urlObj.protocol = 'https:';
    }
    return urlObj.toString();
  } catch {
    // If URL parsing fails, do simple string replacement
    return url.replace(/^http:/, 'https:');
  }
}